import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useSearchParams } from 'react-router-dom'
import { Box, LinearProgress, SelectChangeEvent } from '@mui/material'
import styled from '@emotion/styled'
import SingleSelect from '../../../../components/muiComponents/singleSelect'
import { H3 } from '../../../../layouts/TextStyles'
import { topicApiSlice } from '../../../../features/topic/topicSlice'
import { CourseSubjectState } from '../../../../features/types'
import { VIDEO } from '../../../../utils/constants'
import TopicProgressCard from '../components/TopicProgressCard'

interface Props {
    subjectId: number | null
    studentId: number
    loadingSubjects?: boolean
}

const VideoTab: React.FC<Props> = ({
    subjectId,
    studentId,
    loadingSubjects = false
}) => {
    const { formatMessage } = useIntl()
    const [searchParams] = useSearchParams()
    const [courseSubject, setCourseSubject] = useState(Number(searchParams.get('courseSubjectId')) || null)
    const { data: topics = [], isFetching } =
        topicApiSlice.useGetStudentTopicVideoAnalysisQuery(
            { courseSubjectId: courseSubject, studentId },
            { skip: !courseSubject },
        )

    useEffect(() => {
        if (subjectId) {
            setCourseSubject(subjectId)
        }
    }, [subjectId])

    return (
        <Box>
            {isFetching ? (
                <LinearProgress />
            ) : (
                topics.map((topic) => (
                    <TopicProgressCard
                        key={topic.courseTopicId}
                        topic={topic}
                        studentId={studentId}
                        type={VIDEO}
                    />
                ))
            )}
        </Box>
    )
}

export default VideoTab

